import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import AttributeDataService from "../../services/attribute-data-service/AttributeDataService";
import { IAttribute } from "../../services/attribute-data-service/Models";
import { keys as objectAttributeKeys} from "../object-attributes/Keys";
import { IeLynxObject } from "../../common/models/eLynxObject";

export type MutationContextType = {
    previous: IAttribute[] | undefined;
};

export type UseSaveAttributesParameters = {
    groupID: number,
    organizationID: number,
    eLynxObject: IeLynxObject
} & BaseUseMutationParameters<void, IAttribute[]>;

export function useSaveAttributes({
    groupID,
    organizationID,
    eLynxObject,
    onError,
    onSuccess
}: UseSaveAttributesParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, IAttribute[], MutationContextType>(
        (model) => {
            return AttributeDataService.saveAttributes(
                organizationID,
                groupID,
                model
            );
        },
        {
            onMutate: async (item: IAttribute[]) => {

                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all],
                    active: true,
                    inactive: true
                });


                queryClient.refetchQueries({
                    queryKey: [
                        keys.attributesUsage, 
                        keys.objectsAttributeValues,
                        objectAttributeKeys.attributes
                    ],
                    active: true,
                    inactive: true
                    //type: 'all'
                });

                // if (item.id > 0) {
                //     queryClient.setQueryData<IAttributeSchemaModel>(keys.attributeSchema(organizationID, groupID, item.id), item);
                // }

                //const prev = queryClient.getQueryData<IAttributeSchemaModel>(keys.objectsAttributeValues(organizationID, groupID, ''));

                return {
                    //previous: prev ?? item
                    previous: item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _props, context) => {

                if (error && context?.previous) {
                    queryClient.setQueryData<IAttribute[]>(
                        objectAttributeKeys.attributes(groupID, eLynxObject),
                        context?.previous
                    );
                }

                queryClient.invalidateQueries([keys.all, objectAttributeKeys.all]);
            }            
        }
    );
}
